import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, renderSlot as _renderSlot, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "filter-items" }
const _hoisted_2 = {
  key: 0,
  class: "filter"
}
const _hoisted_3 = { class: "filter-item filter-title" }

import { ref, PropType } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'ListFilter',
  props: {
  options: {
    type: Array as PropType<{ label: string; value: string }[]>,
    default: () => [],
  },
  dense: {
    type: Boolean,
    default: () => false,
  },
},
  emits: ['filter'],
  setup(__props, { emit: __emit }) {

const props = __props;

const emit = __emit;

const filter = ref<string>('');
const filterTitle = ref<string>('');

let to: ReturnType<typeof setTimeout>;
function updateFilter() {
  if (to) {
    clearTimeout(to);
  }
  to = setTimeout(() => {
    emit('filter', { filter: filter.value, filterTitle: filterTitle.value });
  }, 400);
}

function filterByType(type: string) {
  filter.value = filter.value === type ? '' : type;
  updateFilter();
}

return (_ctx: any,_cache: any) => {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createBlock(_component_v_card, {
    elevation: "2",
    class: "filters"
  }, {
    default: _withCtx(() => [
      _createElementVNode("ul", _hoisted_1, [
        _cache[3] || (_cache[3] = _createElementVNode("li", { class: "filter" }, [
          _createElementVNode("label", null, "Filter by:")
        ], -1)),
        (props.options.length)
          ? (_openBlock(), _createElementBlock("li", _hoisted_2, [
              _createVNode(_component_v_btn, {
                flat: "",
                density: "compact",
                color: filter.value === '' ? 'primary' : '',
                onClick: _cache[0] || (_cache[0] = ($event: any) => (filterByType(''))),
                class: _normalizeClass({ small: __props.dense })
              }, {
                default: _withCtx(() => _cache[2] || (_cache[2] = [
                  _createTextVNode("All")
                ])),
                _: 1
              }, 8, ["color", "class"])
            ]))
          : _createCommentVNode("", true),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.options, (option) => {
          return (_openBlock(), _createElementBlock("li", {
            class: "filter-item",
            key: option.label
          }, [
            _createVNode(_component_v_btn, {
              density: "compact",
              flat: "",
              color: filter.value === option.value ? 'primary' : '',
              onClick: ($event: any) => (filterByType(option.value)),
              class: _normalizeClass({ small: __props.dense })
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(option.label), 1)
              ]),
              _: 2
            }, 1032, ["color", "onClick", "class"])
          ]))
        }), 128)),
        _createElementVNode("li", _hoisted_3, [
          _createVNode(_component_v_text_field, {
            modelValue: filterTitle.value,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((filterTitle).value = $event)),
            density: "compact",
            color: "primary",
            label: "Filter",
            variant: "underlined",
            "append-icon": "mdi-magnify",
            "hide-details": "",
            onKeyup: updateFilter
          }, null, 8, ["modelValue"])
        ]),
        _renderSlot(_ctx.$slots, "default")
      ])
    ]),
    _: 3
  }))
}
}

})